"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDuration = exports.formatDuration = void 0;
const types_1 = require("@framework/types");
const formatDuration = (props) => {
    const { durationAmount, durationUnit } = props;
    switch (durationUnit) {
        case types_1.DurationUnit.YEAR:
            return durationAmount * 60 * 60 * 24 * 365;
        case types_1.DurationUnit.MONTH:
            return durationAmount * 60 * 60 * 24 * 30;
        case types_1.DurationUnit.WEEK:
            return durationAmount * 60 * 60 * 24 * 7;
        case types_1.DurationUnit.DAY:
            return durationAmount * 60 * 60 * 24;
        case types_1.DurationUnit.HOUR:
            return durationAmount * 60 * 60;
        case types_1.DurationUnit.MINUTE:
        default:
            return durationAmount * 60;
    }
};
exports.formatDuration = formatDuration;
const normalizeDuration = (props) => {
    const { durationAmount, durationUnit } = props;
    switch (durationUnit) {
        case types_1.DurationUnit.YEAR:
            return durationAmount / 60 / 60 / 24 / 365;
        case types_1.DurationUnit.MONTH:
            return durationAmount / 60 / 60 / 24 / 30;
        case types_1.DurationUnit.WEEK:
            return durationAmount / 60 / 60 / 24 / 7;
        case types_1.DurationUnit.DAY:
            return durationAmount / 60 / 60 / 24;
        case types_1.DurationUnit.HOUR:
            return durationAmount / 60 / 60;
        case types_1.DurationUnit.MINUTE:
        default:
            return durationAmount / 60;
    }
};
exports.normalizeDuration = normalizeDuration;
//# sourceMappingURL=time.js.map